export default __webpack_public_path__ + "static/media/tutorial-install-bot-2.7b0d8ce1.png";